import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=7a943e41"
import script from "./SearchPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports